<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full justify-center">
            <imports-list :context="{ teamId: props.teamId }" importType="conversion" :readOnly="true" embedded>
                <template v-slot:title>Conversion Imports</template>
            </imports-list>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import ImportsList from '~/components/import/ImportsList.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
